import React from "react";

import { ReferencePickerPlugin } from "@adsk/acc-reference-picker";
import EmptyState from "@adsk/alloy-react-empty-state";
import { useLocale } from "@adsk/alloy-react-locale";

import { SystemWithCategoryAndStatus } from "../../models/systems";

const SystemsPickerEmptyState: ReferencePickerPlugin<SystemWithCategoryAndStatus>["CustomPickerEmptyState"] =
  () => {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));
    return (
      <EmptyState
        illustrationType={EmptyState.ILLUSTRATION_TYPES.FOLDER_EMPTY_GREY}
        description={T.translate("ASSETS_PICKER_EMPTY")}
      />
    );
  };

export default SystemsPickerEmptyState;
